import { render, staticRenderFns } from "./set-skill-property.vue?vue&type=template&id=2a01a8fc&scoped=true&"
import script from "./set-skill-property.vue?vue&type=script&lang=js&"
export * from "./set-skill-property.vue?vue&type=script&lang=js&"
import style0 from "./set-skill-property.vue?vue&type=style&index=0&id=2a01a8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a01a8fc",
  null
  
)

export default component.exports